import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';
import { getChartererName } from '../cargoOperationUtils';

export const areCargoCommingleable = (cargo1: RotationCargo, cargo2: RotationCargo): boolean => {
    // TODO: NULL-SAFETY - Missing null/undefined checks for cargo1.product, cargo2.product and their nested properties. Should validate objects exist before property access.
    return (
        getChartererName(cargo1) === getChartererName(cargo2) &&
        cargo1.product.tradeName === cargo2.product.tradeName &&
        cargo1.product.uscgGroup === cargo2.product.uscgGroup
    );
};
